/* hm-header: zaokrąglenie znika po przewinięciu paska ogłoszeń; menu na telefonie (Escape, kotwice zamykają, fokus wraca). */
(function () {
  function init(root) {
    if (!root || root.dataset.hmInit) return;
    root.dataset.hmInit = '1';
    var ann = document.querySelector('.hm-ann'), menu = root.querySelector('.menu'), openBtn = root.querySelector('[data-menu-open]');
    var tick = false;
    function check() { tick = false; root.classList.toggle('stuck', window.scrollY > ((ann ? ann.offsetHeight : 0) - 16)); }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    check();
    function set(o) {
      menu.hidden = !o;
      openBtn.setAttribute('aria-expanded', o);
      document.body.style.overflow = o ? 'hidden' : '';
      (o ? menu.querySelector('[data-menu-close]') : openBtn).focus();
    }
    openBtn.addEventListener('click', function () { set(menu.hidden); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a,[data-menu-close]')) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) set(false); });
  }
  function all() { document.querySelectorAll('[data-hm-header]').forEach(init); }
  all();
  document.addEventListener('shopify:section:load', all);
})();
